import { Component, h, Host, Prop } from '@stencil/core';
import { Size, PillType, BorderType } from '../aha-pill/types';

export interface AhaPill extends HTMLAhaPillElement {}

/**
 * A specific AI-related pill with specific styling. Supports several of the `aha-pill` options for customization.
 *
 * @slot Default - Contents the `aha-ai-pill` element.
 */
@Component({
  tag: 'aha-ai-pill',
  styleUrl: 'aha-ai-pill.css',
  shadow: true,
})
export class AhaAiPill {
  /** The size of the pill. */
  @Prop({ reflect: true }) size: Size = 'mini';

  /**
   * The shape of the border, either square or round.
   */
  @Prop() borderShape?: BorderType = 'round';

  /**
   * Changes the pill to just have a border and the text is the same color
   * as the border
   */
  @Prop() type: PillType = 'solid';

  render() {
    return (
      <Host>
        <aha-pill
          part="aha-pill"
          color="var(--theme-alert-ai-background)"
          textColor="var(--theme-alert-ai-icon-color)"
          size={this.size}
          type={this.type}
          border-shape={this.borderShape}
        >
          <slot></slot>
        </aha-pill>
      </Host>
    );
  }
}
